import React from "react";
import styled from "styled-components";

export const ManualEntry = ({ onExit = () => {}, isStatic }) => {
  return (
    <Container>
      <div className="heading">Manual Entry Enabled</div>
      <div className="text">
        To exit manual entry <ClickHere onClick={onExit}>click here</ClickHere>{" "}
        or press ESC.
      </div>
    </Container>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.palette.secondary};
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4px;
  margin-bottom: 8px;
  .heading {
    font-size: 12px;
  }
  .text {
    font-size: 9px;
  }
`;

const ClickHere = styled.span`
  text-decoration: underline;
  cursor: pointer;
  transition: all 300ms ease;
  &:hover {
    color: white;
  }
`;
